import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import qs from 'qs';

dayjs.extend(customParseFormat);
import * as constants from '../../util/constants';
import helpers from '../../util/helpers';

class AppSearchAccommodations extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      typingTimeout: 0,
      loading: false,
      place: '',
      placeValid: true,
      recentSearches: [],
      recentViewed: [],
      selectedPlace: {},
      allPlaces: [],
      showSuggestions: false,
      showDatesSeperator: false,
      facilities: [],
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.hotels = [];
    this.facilities = [];

    const hotelsObj = window.Rydges['mappedHotels'];
    if (hotelsObj && Object.keys(hotelsObj).length > 0) {
      let hotels = Object.values(hotelsObj);
      hotels = hotels.filter((hotel) => hotel['brand'] === window.Rydges['brand']);
      this.hotels = hotels;
    }

    const availableHotelFacilities = window.Rydges['availableHotelFacilities'];
    if (!$.isEmptyObject(availableHotelFacilities)) {
      this.facilities = Object.keys(availableHotelFacilities).map(function(key) {
        return [key, availableHotelFacilities[key]];
      });
    }

    // Bind "this"
    this.getRecentPlaces = this.getRecentPlaces.bind(this);
    this.onPlaceInputClickFocus = this.onPlaceInputClickFocus.bind(this);
    this.onPlaceInputBlur = this.onPlaceInputBlur.bind(this);
    this.onPlaceInputChange = this.onPlaceInputChange.bind(this);
    this.onPlaceInputKeyDown = this.onPlaceInputKeyDown.bind(this);
    this.onPlaceInputKeyUp = this.onPlaceInputKeyUp.bind(this);
    this.loadPlaceSuggestions = this.loadPlaceSuggestions.bind(this);
    this.onCurrentLocationClick = this.onCurrentLocationClick.bind(this);
    this.onRecentPlaceItemClick = this.onRecentPlaceItemClick.bind(this);
    this.onPlaceItemClick = this.onPlaceItemClick.bind(this);
    this.handleClearPlaceInput = this.handleClearPlaceInput.bind(this);
    this.handleUrlParamsOnInput = this.handleUrlParamsOnInput.bind(this);
    this.handleDateRangePickerChanged = this.handleDateRangePickerChanged.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFacilitiesChanged = this.handleFacilitiesChanged.bind(this);
    this.redirectToSynxis = this.redirectToSynxis.bind(this);
    this.redirectToTelegraph = this.redirectToTelegraph.bind(this);
    this.redirectToInntopia = this.redirectToInntopia.bind(this);
    this.redirectToThredboRates = this.redirectToThredboRates.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    const {
      index,
      autoSubmit,
    } = this.props;

    this.getRecentPlaces();

    if (autoSubmit == '1') {
      const location = helpers.getParameterByName('location');
      if (location != null && location.length) {
        this.setState({place: location});
      }

      const facilities = helpers.getParameterByName('facilities');
      if (facilities != null && facilities.length) {
        this.setState({facilities: facilities.split(',')});
      }
    }

    $(document).trigger(constants.EVENT_BOOKING_FORM_LOADED);

    const dateRangePicker = $('#accommodation-form-date-range-picker-' + index);
    if (dateRangePicker.length) {
      dateRangePicker.on('daterangepicker_changed', this.handleDateRangePickerChanged);
    }
  }

  redirectToTelegraph({
    hotelCode,
    hotelBrand,
    startDate,
    endDate,
    numGuests,
    dateFormat,
  }) {
    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const {
      DEFAULT_DATE_FORMAT,
      TELEGRAPH_CONSTANTS: {
        TELEGRAPH_URL,
        TELEGRAPH_HOTEL_ID,
        TELEGRAPH_DATE_DEFAULT_JS_FORMAT,
      },
    } = BookingWidget.constants;

    const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
      const location = BookingWidget['allBrandsLocations'][key];
      return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
    });

    if (!hotelKey) {
      return false;
    }

    const hotelData = BookingWidget['allBrandsLocations'][hotelKey];
    const redirectToTelegraph = hotelData['redirectToTelegraph'];

    if (!redirectToTelegraph) {
      return false;
    }

    const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

    const arriveMoment = moment(startDate, bookingDateFormat);
    let arrival = startDate;

    if (arriveMoment.isValid()) {
      arrival = arriveMoment.format(TELEGRAPH_DATE_DEFAULT_JS_FORMAT);
    }

    const departMoment = moment(endDate, bookingDateFormat);
    let departure = endDate;

    if (departMoment.isValid()) {
      departure = departMoment.format(TELEGRAPH_DATE_DEFAULT_JS_FORMAT);
    }

    const rooms = numGuests.length;

    const params = {
      hotel: TELEGRAPH_HOTEL_ID,
      arrival,
      departure,
      rooms,
      codeType: 'promo',
      code: '',
    };

    numGuests.forEach((guest, idx) => {
      const {
        numAdults,
        numChildren,
      } = guest;

      params[`adults[${idx + 1}]`] = isNaN(numAdults)? 0 : numAdults;
      params[`children[${idx + 1}]`] = isNaN(numChildren)? 0 : numChildren;
    });

    const qsParams = Object.keys(params).map((key) => {
      const value = params[key];

      if (!value) {
        return null;
      }

      return `${key}=${value}`;
    }).filter((param) => !!param).join('&');

    window.open(`${TELEGRAPH_URL}/?${qsParams}`, '_blank');

    return true;
  }

  redirectToSynxis({
    hotelCode,
    hotelBrand,
    startDate,
    endDate,
    numGuests,
    dateFormat,
  }) {
    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const {
      DEFAULT_DATE_FORMAT,
      SYNXIS_CONSTANTS: {
        SYNXIS_URL,
        SYNXIS_DATE_DEFAULT_JS_FORMAT,
        SYNXIS_BRAND_CODES,
      },
    } = BookingWidget.constants;

    const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
      const location = BookingWidget['allBrandsLocations'][key];
      return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
    });

    if (!hotelKey) {
      return false;
    }

    const hotelData = BookingWidget['allBrandsLocations'][hotelKey];
    const synxisSettings = hotelData['synxisSettings'];
    const brand = hotelData['brand'];
    const ratesApiSource = hotelData['ratesApiSource'];

    if (!synxisSettings) {
      return false;
    }

    const synxisBrandCode = SYNXIS_BRAND_CODES[brand];

    if (!synxisBrandCode) {
      return false;
    }

    if (ratesApiSource !== 'ireckonu_api') {
      return false;
    }

    if (
      !synxisSettings.enableSynxisHotel
      || !synxisSettings.synxisChainId
    ) {
      return false;
    }

    const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

    const arriveMoment = moment(startDate, bookingDateFormat);
    let arrive = startDate;

    if (arriveMoment.isValid()) {
      arrive = arriveMoment.format(SYNXIS_DATE_DEFAULT_JS_FORMAT);
    }

    const departMoment = moment(endDate, bookingDateFormat);
    let depart = endDate;

    if (departMoment.isValid()) {
      depart = departMoment.format(SYNXIS_DATE_DEFAULT_JS_FORMAT);
    }

    const adultsCounts = [];
    const childrenCounts = [];

    numGuests.forEach((guest) => {
      const {
        numAdults,
        numChildren,
      } = guest;

      adultsCounts.push(isNaN(numAdults)? 0 : numAdults);
      childrenCounts.push(isNaN(numChildren)? 0 : numChildren);
    });

    const adult = adultsCounts.join(',');
    const child = childrenCounts.join(',');

    const rooms = numGuests.length;

    const params = {
      Hotel: synxisSettings.synxisHotelId,
      Chain: synxisSettings.synxisChainId,
      theme: synxisBrandCode,
      config: synxisBrandCode,
      arrive,
      depart,
      rooms,
      adult,
      child,
    };

    const qsParams = Object.keys(params).map((key) => {
      const value = params[key];

      if (!value) {
        return null;
      }

      return `${key}=${value}`;
    }).filter((param) => !!param).join('&');

    window.open(`${SYNXIS_URL}/?${qsParams}`, '_blank');

    return true;
  }

  redirectToThredboRates({
    hotelCode,
    hotelBrand,
    numGuests,
    startDate,
    endDate,
  }) {
    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const {
      DEFAULT_DATE_FORMAT,
      THREDBO_CONSTANTS: {
        RATES_URL,
        BRAND: THREDBO_BRAND,
        HOTEL_CODE: THREDBO_HOTEL_CODE,
      },
    } = BookingWidget.constants;

    const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
      const location = BookingWidget['allBrandsLocations'][key];
      return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
    });

    if (!hotelKey) {
      return false;
    }

    const hotelData = BookingWidget['allBrandsLocations'][hotelKey];

    if (!hotelData['redirectToThredboRates']) {
      return false;
    }

    const rooms = numGuests.length;
    const adultsPerRoom = [];
    const kidsPerRoom = [];
    const childAgesPerRoom = [];

    numGuests.forEach((guest) => {
      const {
        numAdults,
        numChildren,
      } = guest;

      const adultCount = isNaN(numAdults) ? 0 : Number(numAdults);
      const kidCount = isNaN(numChildren) ? 0 : Number(numChildren);

      adultsPerRoom.push(adultCount);
      kidsPerRoom.push(kidCount);
      childAgesPerRoom.push(kidCount > 0 ? Array(kidCount).fill(0).join(',') : '');
    });

    const adults = adultsPerRoom.join(',');
    const kids = kidsPerRoom.join(',');
    const childAges = childAgesPerRoom.filter((ages) => ages !== '').join('|');

    const checkinDayjs = dayjs(startDate, DEFAULT_DATE_FORMAT);
    const checkin = checkinDayjs.isValid() ? checkinDayjs.format('YYYY-MM-DD') : null;
    const checkoutDayjs = dayjs(endDate, DEFAULT_DATE_FORMAT);
    const checkout = checkoutDayjs.isValid() ? checkoutDayjs.format('YYYY-MM-DD') : null;

    const params = {
      brand: THREDBO_BRAND,
      hotelCode: THREDBO_HOTEL_CODE,
      rooms,
      adults,
      kids,
      childAges,
      checkin,
      checkout,
    };

    const qsParams = Object.keys(params).map((key) => {
      const value = params[key];

      if (value === '' || value === null || value === undefined) {
        return null;
      }

      return `${key}=${value}`;
    }).filter((param) => !!param).join('&');

    const [ratesBaseUrl, ratesHash] = RATES_URL.split('#');
    const ratesUrl = ratesHash ? `${ratesBaseUrl}?${qsParams}/#${ratesHash}` : `${ratesBaseUrl}?${qsParams}`;
    window.open(ratesUrl, '_blank');

    return true;
  }

  redirectToInntopia({
    hotelCode,
    hotelBrand,
    startDate,
    endDate,
    numGuests,
    dateFormat,
  }) {
    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const {
      DEFAULT_DATE_FORMAT,
      INNTOPIA_CONSTANTS: {
        INNTOPIA_URL,
        INNTOPIA_SUPPLIER_ID,
        INNTOPIA_DATE_DEFAULT_JS_FORMAT,
        INNTOPIA_HOTEL_CODE,
      },
    } = BookingWidget.constants;

    if (hotelCode !== INNTOPIA_HOTEL_CODE) {
      return false;
    }

    const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
      const location = BookingWidget['allBrandsLocations'][key];
      return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
    });

    if (!hotelKey) {
      return false;
    }

    const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

    const arriveMoment = moment(startDate, bookingDateFormat);
    let arrival = startDate;

    if (arriveMoment.isValid()) {
      arrival = arriveMoment.format(INNTOPIA_DATE_DEFAULT_JS_FORMAT);
    }

    const departMoment = moment(endDate, bookingDateFormat);
    let departure = endDate;

    if (departMoment.isValid()) {
      departure = departMoment.format(INNTOPIA_DATE_DEFAULT_JS_FORMAT);
    }

    const params = {
      supplierid: INNTOPIA_SUPPLIER_ID,
      arrivaldate: arrival,
      departuredate: departure,
    };

    numGuests.forEach((guest) => {
      const {
        numAdults,
        numChildren,
      } = guest;

      params['adultcount'] = isNaN(numAdults)? 0 : numAdults;
      params['childCount'] = isNaN(numChildren)? 0 : numChildren;
    });

    params['childagearray'] = '#Availability';

    const qsParams = Object.keys(params).map((key) => {
      const value = params[key];

      if (!value) {
        return null;
      }

      return `${key}=${value}`;
    }).filter((param) => !!param).join('&');

    window.open(`${INNTOPIA_URL}/?${qsParams}`, '_blank');

    return true;
  }

  getRecentPlaces() {
    const recentSearches = JSON.parse(helpers.docCookies.getItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_SEARCHES)) || [];
    const recentViewed = JSON.parse(helpers.docCookies.getItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_VIEWED)) || [];

    if (null !== recentSearches) {
      this.setState({recentSearches});
    } else {
      this.setState({recentSearches: []});
    }

    if (null !== recentViewed) {
      this.setState({recentViewed});
    } else {
      this.setState({recentViewed: []});
    }
  }

  onPlaceInputClickFocus(e) {
    e.preventDefault();

    const {
      loading,
      place,
      allPlaces,
    } = this.state;

    if (!loading && place !== 'Current Location') {
      this.setState({showSuggestions: true});

      if (place.length > 0 && allPlaces.length === 0) {
        this.loadPlaceSuggestions();
      }
    }
  }

  onPlaceInputBlur() {
    const OS = navigator.userAgent;

    // match if OS has Windows
    // bug fix for Windows browsers for not updating locaton input
    const delay = OS.match(/Windows/i) ? 500 : 200;

    // Add delay to fire click events before hiding
    setTimeout(() => {
      this.setState({showSuggestions: false});
    }, delay);
  }

  onPlaceInputChange(e) {
    const value = e.target.value;

    this.setState({place: value});
  }

  onPlaceInputKeyDown() {
    this.setState({showSuggestions: false});
  }

  onPlaceInputKeyUp() {
    const {
      typingTimeout,
      loading,
      place,
    } = this.state;

    if (place.length == 0) {
      this.setState({
        typingTimeout: 0,
        loading: false,
        placeValid: true,
        selectedPlace: {},
        allPlaces: [],
      });
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    } else {
      if (typingTimeout || loading) {
        if (loading) {
          this.setState({
            typingTimeout: 0,
            loading: false,
            placeValid: false,
            selectedPlace: {},
            allPlaces: [],
            showSuggestions: false,
          });
          this.source.cancel('Cancelled retrieving data');
          this.source = axios.CancelToken.source(); // Generate new source token
        }

        clearTimeout(typingTimeout);
      }

      this.setState({
        typingTimeout: setTimeout(() => {
          this.loadPlaceSuggestions();
        }, 500),
      });
    }
  }

  loadPlaceSuggestions() {
    const {
      loading,
      place,
    } = this.state;

    // Stop loading old results
    if (loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    this.setState({
      loading: true,
      placeValid: false,
      selectedPlace: {},
      allPlaces: [],
      showSuggestions: false,
    });

    const data = {
      'action': constants.ACTION_GET_ACCOMMODATION_PLACES,
      'query': place,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const places = [...response.data['places']];

          this.setState({
            loading: false,
            selectedPlace: {},
            allPlaces: places,
            showSuggestions: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  onCurrentLocationClick(e) {
    e.preventDefault();

    const currentLocationLabel = 'Current Location';

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        () => {},
        () => {}
      );
    }

    this.setState({
      place: currentLocationLabel,
      placeValid: true,
      selectedPlace: {},
      showSuggestions: false,
    });

    this.handleUrlParamsOnInput(currentLocationLabel);
  }

  onRecentPlaceItemClick(e, placeItem) {
    e.preventDefault();

    this.setState({
      place: placeItem['name'],
      placeValid: true,
      selectedPlace: {
        name: placeItem['name'],
        brand: placeItem['brand'],
      },
      showSuggestions: false,
    });

    $(document).trigger(constants.EVENT_BOOKING_SEARCH_PLACE_CHANGED, [placeItem['name']]);
    this.handleUrlParamsOnInput(placeItem['name']);
  }

  onPlaceItemClick(e, placeCategoryTitle, placeItem) {
    e.preventDefault();

    this.setState({
      place: placeItem['name'],
      placeValid: true,
      selectedPlace: {
        name: placeItem['name'],
        brand: placeItem['brand'],
      },
      allPlaces: [
        {
          title: placeCategoryTitle,
          places: [
            placeItem,
          ],
        },
      ],
      showSuggestions: false,
    });

    $(document).trigger(constants.EVENT_BOOKING_SEARCH_PLACE_CHANGED, [placeItem['name']]);
    this.handleUrlParamsOnInput(placeItem['name']);
  }

  handleClearPlaceInput(e) {
    e.preventDefault();

    this.setState({
      typingTimeout: 0,
      loading: false,
      place: '',
      placeValid: true,
      selectedPlace: {},
      allPlaces: [],
      showSuggestions: false,
    });

    $(document).trigger(constants.EVENT_BOOKING_SEARCH_PLACE_CHANGED, ['']);
    this.handleUrlParamsOnInput();
  }

  handleUrlParamsOnInput(location = '') {
    const { autoSubmit } = this.props;

    if (autoSubmit == '1') {
      const params = helpers.getParameters();

      if (location.length > 0) {
        params['location'] = location;
      } else {
        delete params['location'];
      }

      helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');
    }

    return;
  }

  handleDateRangePickerChanged() {
    const { index } = this.props;
    const dateRangePicker = $('#accommodation-form-date-range-picker-' + index);
    if (dateRangePicker.length) {
      const form = dateRangePicker.closest('form.search-accommodations-form');
      const startDate = form.find('[name="startDate"]').val();
      const endDate = form.find('[name="endDate"]').val();

      if (startDate !== '' && endDate !== '') {
        this.setState({showDatesSeperator: true});
      } else {
        this.setState({showDatesSeperator: false});
      }
    }
  }

  validateNRMA() {
    if (!window.NRMA_Membership) {
      return true;
    }

    if (typeof window.NRMA_Membership.isNrmaLandingPage !== 'function') {
      return true;
    }

    if (!window.NRMA_Membership.isNrmaLandingPage()) {
      return true;
    }

    if (typeof window.NRMA_Membership.validate !== 'function') {
      return true;
    }

    return window.NRMA_Membership.validate();
  }

  getNRMAToken() {
    if (!window.NRMA_Membership) {
      return null;
    }

    if (typeof window.NRMA_Membership.getToken !== 'function') {
      return null;
    }

    return window.NRMA_Membership.getToken();
  }

  handleSubmit(e) {
    e.preventDefault();

    const {
      autoSubmit,
      hotelSubmitDestination,
      submitUrlBase,
    } = this.props;
    const {
      place,
      placeValid,
      selectedPlace,
    } = this.state;
    const form = $(e.target);
    const brand = selectedPlace && selectedPlace['brand'] ? selectedPlace['brand'] : window.Rydges.brand;
    const hotelKey = `${place}|${brand}`;

    if (placeValid) {
      const startDateVal = form.find('[name="startDate"]').val();
      const endDateVal = form.find('[name="endDate"]').val();
      let startDate = '';
      let endDate = '';
      let submitUrl = '';

      if (startDateVal !== '' && startDateVal !== '') {
        startDate = moment(new Date(startDateVal)).format(constants.DATE_FORMAT_AUS);
        endDate = moment(new Date(endDateVal)).format(constants.DATE_FORMAT_AUS);
      }

      const numGuests = [{
        numAdults: 2,
        numChildren: 0,
      }];

      let location = window.BookingWidget['allBrandsLocations'][hotelKey];

      if (location && startDate && endDate) {
        const hotelCode = location['hotelCode'];
        const hotelBrand = location['brand'];
        const startDate = startDateVal;
        const endDate = endDateVal;

        // Redirect to Thredbo Rates
        if (this.redirectToThredboRates({
          hotelCode,
          hotelBrand,
          numGuests,
          startDate,
          endDate,
        })) {
          return;
        }

        // Redirect to Inntopia
        if (this.redirectToInntopia({
          hotelCode,
          hotelBrand,
          startDate,
          endDate,
          numGuests,
        })) {
          return;
        }

        if (this.redirectToSynxis({
          hotelCode,
          hotelBrand,
          startDate,
          endDate,
          numGuests,
        })) {
          return;
        }

        if (this.redirectToTelegraph({
          hotelCode,
          hotelBrand,
          startDate,
          endDate,
          numGuests,
        })) {
          return;
        }
      }

      if ('undefined' !== typeof window.Rydges['mappedHotels'][hotelKey]) {
        location = window.Rydges['mappedHotels'][hotelKey];

        if (startDate !== '' && endDate !== '' && location['hotel_code'].length > 0) {
          const params = {
            hotelCode: location['hotel_code'],
            startDate: startDate,
            endDate: endDate,
            numRooms: 1,
            numGuests,
          };

          if ('booking_target' in location) {
            params.channelCode = location['booking_target']['channel_code'];
          } else {
            params.channelCode = window.Rydges['defaultChannelCode'];
          }

          if ('booking_target' in location && (location['booking_target']['domain'] !== 'rydges.com')) {
            const nrmaToken = this.getNRMAToken(); // No need to url encode since jQuery param takes care of that
            submitUrl = location['booking_target']['rates_page'] + '?' + $.param({
              ...params,
              nrmaToken,
            });
          } else {
            helpers.docCookies.setItem('rsd_ba_b', JSON.stringify(params), 3600, '/', 'rydges.com');
            submitUrl = window.Rydges['ratesPageUrl'];
          }
        } else if ( hotelSubmitDestination === 'rates_page' ) {
          const params = {
            hotelCode: location['hotel_code'],
            numRooms: 1,
            numGuests,
          };

          if ('booking_target' in location && (location['booking_target']['domain'] !== 'rydges.com')) {
            const nrmaToken = this.getNRMAToken(); // No need to url encode since jQuery param takes care of that
            submitUrl = location['booking_target']['rates_page'] + '?' + $.param({
              ...params,
              nrmaToken,
            });
          } else {
            helpers.docCookies.setItem('rsd_ba_b', JSON.stringify(params), 3600, '/', 'rydges.com');
            submitUrl = window.Rydges['ratesPageUrl'];
          }
        } else {
          submitUrl = location['url'].replace(/\/?$/, '/');
        }
      } else if (autoSubmit == '' && submitUrlBase.length > 0) {
        submitUrl = submitUrlBase + '?location=' + encodeURIComponent(place);
      }

      if (startDate === '' && endDate === '') {
        helpers.docCookies.setItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_START_DATE, '', 1500, '/', 'rydges.com');
        helpers.docCookies.setItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_END_DATE, '', 1500, '/', 'rydges.com');
      }

      if (submitUrl.length > 0) {
        if (!this.validateNRMA()) {
          return;
        }

        window.location = submitUrl;
      } else if (autoSubmit == '1') {
        $(document).trigger(constants.EVENT_SUBMIT_CLICKED_SEARCH, [place, startDate, endDate]);
      }

      // Save to recent searches
      if (place !== null && place.length && place !== 'Current Location') {
        let recentSearches = JSON.parse(helpers.docCookies.getItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_SEARCHES)) || [];
        if (null !== recentSearches) {
          const data = {
            name: selectedPlace['name'],
            brand: selectedPlace['brand'],
          };

          // Avoid duplicated saved recent searches
          recentSearches = recentSearches.filter((item) => item['name'] !== data['name']);
          recentSearches.unshift(data);

          this.setState({recentSearches});

          // Save last 3 searches to cookie
          helpers.docCookies.setItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_SEARCHES, JSON.stringify(recentSearches.slice(0, 3)), 30 * 86400, '/');
        }
      }
    }
  }

  handleFacilitiesChanged(e) {
    const value = e.target.value;
    const { facilities } = this.state;
    let selectedFacilities = [...facilities];

    if (event.target.checked) {
      selectedFacilities.push(value);
    } else {
      selectedFacilities = selectedFacilities.filter((facility) => {
        return facility != value;
      });
    }

    this.setState({facilities: selectedFacilities});

    const selectedFacilitiesString = selectedFacilities.join();
    const params = helpers.getParameters();

    if (selectedFacilitiesString.length > 0) {
      params['facilities'] = selectedFacilitiesString;
    } else {
      delete params['facilities'];
    }

    helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

    $(document).trigger(constants.EVENT_FACILITES_FILTER_CHANGED_SEARCH, [selectedFacilitiesString]);
  }

  render() {
    const {
      index,
      autoSubmit,
      showFilters,
    } = this.props;
    const {
      loading,
      place,
      placeValid,
      recentSearches,
      recentViewed,
      allPlaces,
      showSuggestions,
      showDatesSeperator,
      facilities,
    } = this.state;

    return (
      <Fragment>
        <form action="#" className="position-relative search-accommodations-form" onSubmit={this.handleSubmit}>
          <div className="inner-content bg-white pt-3 pb-3 pt-4 py-lg-3 pr-lg-4">
            <div className="row">
              <div className="col-lg-5">
                <label className="mb-0 d-block position-relative pr-4 pr-lg-0">
                  Destination
                  <input className="where place-search"
                         value={place}
                         type="text"
                         name="place"
                         autoComplete="off"
                         onClick={this.onPlaceInputClickFocus}
                         onFocus={this.onPlaceInputClickFocus}
                         onBlur={this.onPlaceInputBlur}
                         onChange={this.onPlaceInputChange}
                         onKeyDown={this.onPlaceInputKeyDown}
                         onKeyUp={this.onPlaceInputKeyUp}
                         placeholder="Location, hotel name"
                  />
                  {
                    place.length === 0 && showSuggestions && (
                      <div className="recent-place-suggestions-wrapper">
                        <div className="current-location-wrapper">
                          <div className="recent-place-item current-location-item"
                               onClick={this.onCurrentLocationClick}
                          >
                            <img src={window.Rydges['assetsPath'] + 'images/icons/plane-2.svg'} className="icon mr-2" />
                            <span className="name">Current Location</span>
                          </div>
                        </div>
                        {
                          (recentSearches.length > 0 || recentViewed.length > 0)
                            ? (
                              <div className="recent-place-suggestions">
                                {
                                  recentSearches.length > 0 && (
                                    <div className="recent-place-category-wrapper">
                                      <div className="recent-place-category-title">
                                        Recent Searches
                                      </div>
                                      {
                                        recentSearches.map((placeItem, i) => {
                                          return (
                                            <div key={i}
                                                 className="recent-place-item"
                                                 onClick={(e) => this.onRecentPlaceItemClick(e, placeItem)}
                                            >
                                              <img src={window.Rydges['assetsPath'] + 'images/icons/clock.svg'} className="icon mr-2" />
                                              <span className="name">{placeItem['name']}</span>
                                            </div>
                                          );
                                        })
                                      }
                                    </div>
                                  )
                                }
                                {
                                  recentViewed.length > 0 && (
                                    <div className="recent-place-category-wrapper">
                                      <div className="recent-place-category-title">
                                        Recently Viewed
                                      </div>
                                      {
                                        recentViewed.map((placeItem, i) => {
                                          return (
                                            <div key={i}
                                                 className="recent-place-item"
                                                 onClick={(e) => this.onRecentPlaceItemClick(e, placeItem)}
                                            >
                                              <img src={window.Rydges['assetsPath'] + 'images/icons/clock.svg'} className="icon mr-2" />
                                              <span className="name">{placeItem['name']}</span>
                                            </div>
                                          );
                                        })
                                      }
                                    </div>
                                  )
                                }
                              </div>
                            ) : (
                              <Fragment>
                                {
                                  this.hotels.length > 0 && (
                                    <div className="recent-place-suggestions">
                                      <div className="recent-place-category-wrapper">
                                        <div className="recent-place-category-title">
                                          Hotels
                                        </div>
                                        {
                                          this.hotels.map((placeItem, i) => {
                                            return (
                                              <div key={i}
                                                   className="recent-place-item"
                                                   onClick={(e) => this.onRecentPlaceItemClick(e, placeItem)}
                                              >
                                                <img src={window.Rydges['assetsPath'] + 'images/icons/bed-icon.svg'} className="icon mr-2" />
                                                <span className="name">{placeItem['name']}</span>
                                              </div>
                                            );
                                          })
                                        }
                                      </div>
                                    </div>
                                  )
                                }
                              </Fragment>
                            )
                        }
                      </div>
                    )
                  }
                  {
                    place.length > 0 && (
                      <Fragment>
                        {
                          showSuggestions && (
                            <div className="place-suggestions-wrapper">
                              {
                                allPlaces.length > 0
                                  ? (
                                    <Fragment>
                                      {
                                        allPlaces.map((placeCat, i) => {
                                          return (
                                            <Fragment key={i}>
                                              {
                                                placeCat['places'].length > 0 && (
                                                  <div className="place-category-wrapper">
                                                    {
                                                      placeCat['title'].length > 0 && (
                                                        <div className="place-category-title">
                                                          {placeCat['title']}
                                                        </div>
                                                      )
                                                    }
                                                    {
                                                      placeCat['places'].map((placeItem, j) => {
                                                        return (
                                                          <div key={j}
                                                               className="place-item"
                                                               {...placeItem['attribs']}
                                                               onClick={(e) => this.onPlaceItemClick(e, placeCat['title'], placeItem)}
                                                          >
                                                            <img src={placeItem['icon']} className="icon mr-2" />
                                                            <span className="name">{placeItem['name']}</span>
                                                          </div>
                                                        );
                                                      })
                                                    }
                                                  </div>
                                                )
                                              }
                                            </Fragment>
                                          );
                                        })
                                      }
                                    </Fragment>
                                  ) : (
                                    <div className="no-results-found">No results found</div>
                                  )
                              }
                            </div>
                          )
                        }
                        {
                          !loading
                            ? (
                              <Fragment>
                                {
                                  allPlaces.length > 0 && (
                                    <div className="" />
                                  )
                                }
                                <div className="clear-button" onClick={this.handleClearPlaceInput}>
                                  <div className="d-flex align-items-center">
                                    <span className="mr-2 text-lowercase">Clear</span>
                                    <img src={window.Rydges['assetsPath'] + 'images/icons/times.svg'} className="img-fluid" />
                                  </div>
                                </div>
                              </Fragment>
                            ) : (
                              <div className="loading-icon">
                                <div className="spinner-loader" />
                              </div>
                            )
                        }
                      </Fragment>
                    )
                  }
                </label>
              </div>

              <div className="col-12 d-lg-none">
                <hr className="w-100" />
              </div>

              <div className="col-lg-6">
                <label className="position-relative mb-0 d-block pr-0 pr-lg-5">
                  Dates
                  <input id={'accommodation-form-date-range-picker-' + index}
                    className={'booking-daterange-picker ' + (!showDatesSeperator ? 'hidden-end-date' : '')}
                    type="text"
                    autoComplete="off"
                    defaultValue=""
                    readOnly
                    data-cookie-start-date={constants.COOKIE_KEY_ACCOMMODATION_SEARCH_START_DATE}
                    data-cookie-end-date={constants.COOKIE_KEY_ACCOMMODATION_SEARCH_END_DATE}
                    data-cookie-populate={autoSubmit == '1' ? 'on' : 'off'}
                  />
                  <div className="when input-dates-wrapper">
                    <input className="w-100 check-in"
                      type="text"
                      readOnly
                      name="checkin"
                      placeholder="I'm Flexible"
                    />
                    <input type="hidden" name="startDate" />
                    {
                      showDatesSeperator && (
                        <span className="px-3 input-date-separator">-</span>
                      )
                    }
                    <input className="w-100 check-out"
                      type="text"
                      readOnly
                      name="checkout"
                      placeholder=""
                    />
                    <input type="hidden" name="endDate" />
                  </div>
                </label>
              </div>
              <div className="btn-container">
                <button type="submit" className="btn btn-red btn-md" disabled={loading || !placeValid}><span>GO</span></button>
              </div>
            </div>
          </div>
        </form>
        {
          (showFilters == '1') && (
            <div className="form-filters mt-3 d-flex flex-column flex-lg-row align-items-center justify-content-between">
              {
                this.facilities.length > 0 && (
                  <div className="facilities-filter search-form-filter-dropdown dropdown mb-3 mb-lg-0">
                    <button className={'btn btn-filter dropdown-toggle px-3 py-2 w-100 ' + (facilities.length > 0 ? 'active' : '')} type="button" id="facilities-dropdown-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Facilities
                    </button>
                    <div className="dropdown-menu mt-2 p-3" aria-labelledby="facilities-dropdown-menu">
                      <div className="row">
                        {
                          helpers.divideArray(this.facilities, Math.ceil(this.facilities.length / 2)).map((hotelFacilitiesCol, i) => {
                            return (
                              <div key={i} className="col-12 col-lg-6">
                                {
                                  hotelFacilitiesCol.map((facility, j) => {
                                    return (
                                      <div key={j} className="custom-checkbox mb-3">
                                        <input id={facility[0]}
                                               type="checkbox"
                                               name="facility"
                                               value={facility[0]}
                                               onChange={this.handleFacilitiesChanged}
                                               checked={facilities.indexOf(facility[0]) > -1}
                                        />
                                        <label htmlFor={facility[0]}>
                                          {facility[1]}
                                        </label>
                                      </div>
                                    );
                                  })
                                }
                              </div>
                            );
                          })
                        }
                      </div>
                    </div>
                  </div>
                )
              }
            </div>
          )
        }
      </Fragment>
    );
  }
}

AppSearchAccommodations.propTypes = {
  index: PropTypes.number.isRequired,
  autoSubmit: PropTypes.string,
  hotelSubmitDestination: PropTypes.string,
  showFilters: PropTypes.string,
  submitUrlBase: PropTypes.string,
};

AppSearchAccommodations.defaultProps = {
  autoSubmit: '',
  hotelSubmitDestination: '',
  showFilters: '',
  submitUrlBase: '',
};


const searchAccommodations = () => {
  jQuery(document).ready(function($) {
    const accommodationsFormWrapper = $('.search-accommodations-form-wrapper');
    if (accommodationsFormWrapper.length) {
      for (let i = 0; i < accommodationsFormWrapper.length; i++) {
        const formProps = {...accommodationsFormWrapper[i].dataset};

        ReactDOM.render(<AppSearchAccommodations index={i} {...formProps} />, accommodationsFormWrapper[i]);
      }

      $(document).on('click', '.form-filters .search-form-filter-dropdown .dropdown-menu *', function (e) {
        e.stopPropagation();
      });
    }
  });
};

export default searchAccommodations;



// WEBPACK FOOTER //
// ./scripts/routes/modules/searchAccommodations.js